<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'
import { useWebSiteStore } from '@/stores/web-site.store'
import { useRoiComparisonFormat } from '@/composables/roi-comparison'

const props = defineProps({
  comparison: {
    type: Object,
    required: true,
  },
})

const i18n = getI18n()
const webSiteStore = useWebSiteStore()
const { itemName, referenceRow: findReferenceRow } = useRoiComparisonFormat()

const referenceRow = computed(() => findReferenceRow(props.comparison))
const hasActiveOptions = computed(() => webSiteStore.roiComparisonShowDelta || webSiteStore.roiComparisonDifferencesOnly)
</script>

<template>
  <div class="row no-wrap items-center q-gutter-x-sm">
    <q-icon name="mdi-target" color="primary" size="1rem" />
    <div class="col text-caption ellipsis">
      <span class="text-grey-7">{{ i18n.t('common.reference') }}: </span>
      <span class="text-weight-medium">{{ referenceRow ? itemName(comparison.type, referenceRow.item) : '—' }}</span>
    </div>
    <q-btn
      flat
      round
      size="sm"
      icon="mdi-tune"
      :color="hasActiveOptions ? 'primary' : 'grey-7'"
    >
      <q-badge
        v-if="hasActiveOptions"
        floating
        rounded
        color="primary"
      />
      <q-tooltip>{{ i18n.t('roiCompare.viewOptions') }}</q-tooltip>
      <q-menu>
        <q-list style="min-width: 17rem;">
          <q-item-label header class="text-caption q-pb-none">{{ i18n.t('roiCompare.viewOptions') }}</q-item-label>
          <q-item>
            <q-toggle
              v-model="webSiteStore.roiComparisonShowDelta"
              :label="i18n.t('roiCompare.showDelta')"
              class="full-width"
            />
          </q-item>
          <q-item>
            <q-toggle
              v-model="webSiteStore.roiComparisonDifferencesOnly"
              :label="i18n.t('roiCompare.diffOnly')"
              class="full-width"
            />
          </q-item>
        </q-list>
      </q-menu>
    </q-btn>
  </div>
</template>
